import ApiKeyUsersView from 'js/views/apiKeys.generic.view';
import Template from 'js/templates/redeemers.hbs';
import RedemptionsView from 'js/views/redemptions.view';
//import ApiKeyUsersModel from 'js/models/apiKeyUsers.model';
import i18n from 'l10n';
import dhtmlx from "dhtmlxAdapter";
import {el, model, on, tagName, template} from 'js/adapters/backbone-decorators';

@el("#manage-redeemers-container")
//@model(ApiKeyUsersModel)
@tagName("div")
@template(Template)
class RedeemersView extends ApiKeyUsersView {
    constructor(props) {
        super(props);

        this.collection.url = `${this.collectionUrl}/${this.userRole}`;

        // render the collection only on the first time
        this.renderCollection();
    }

    // noinspection JSMethodCanBeStatic
    // @Override
    get userRole() {
        return 'Redeemers';
    }

    // noinspection JSMethodCanBeStatic
    // @Override
    get className() {
        return '';
    }

    render() {
        this.renderPagination(this.pagination, this.collection, '#pagination');
        this.showHideNoFoundRedeemers(this.collection.count);
        const redeemersOf = i18n.t("voucher.redeemersOf", {outOf: this.collection.count});
        this.$(".redeemersOf").text(`(${this.collection.data.length} ${redeemersOf})`);

        return this;
    }

    renderVoucherRedemptions() {
        const redeemer = this.collection.data.find(({id}) => id === this.lastClickedRedeemerId);

        this.redemptionsView = new RedemptionsView({redeemer});
        this.redemptionsView.on("change:user", user => this.refreshUser(user.id, user));
        this.redemptionsView.on("change:apiKey", user => this.refreshKey(user.id));
    }

    @on('click #copyToClipboard')
    copyToClipboard() {
        var redeemerLinkText = $('#currentRedeemerUrl').text().trim();
        var tempTextArea = document.createElement('textarea');
        //BE EXTRA CAREFUL. CHROME CANNOT SELECT WHEN display IS SET TO none
        tempTextArea.style = 'opacity: 0;z-index: 555;position: fixed;';
        document.body.appendChild(tempTextArea);
        tempTextArea.textContent = redeemerLinkText;
        tempTextArea.select();
        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }
    }

    @on('click .submitNewUserInfo')
    async submitUserInfo() {
        var description = this.$(".description").val();
        var emailText = this.$(".email").val();
        if (!description || $.trim(description).length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return;
        }
        if (!emailText || $.trim(emailText).length === 0) {
            dhtmlx.alert(i18n.t("engagement.fieldMustNotBeEmpty"));
            return;
        }

        this.toggleNewUserButton(true);
        const postData = {description: description, email: emailText};

        await this.createUser(postData);

    }

    @on('click .viewDetails')
    viewRedeemerDetails(evt) {
        const redeemerRow = $(evt.currentTarget).closest('[data-user-id]');
        this.lastClickedRedeemerId = parseInt($(redeemerRow).attr("data-user-id"));

        $.Dialog({
            overlay: true,
            shadow: true,
            title: i18n.t('voucher.redeemerInformation'),
            draggable: false,
            height: 'auto',
            position: ['center', 'center'],
            content: '<div id="redemptionDetails" class="scrollable-window"></div>',
            padding: 0,
            onShow: this.renderVoucherRedemptions.bind(this)
        });
    }
}

export default RedeemersView;